// import React, { useEffect, useState } from 'react';
// import Chip from '@mui/material/Chip';
// import TextField from '@mui/material/TextField';
// import Button from '@mui/material/Button';
// import { DndProvider, useDrag, useDrop } from 'react-dnd';
// import { HTML5Backend } from 'react-dnd-html5-backend';
// import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
// const DragTypes = {
//   CHIP: 'chip',
// };

// const DraggableChip = ({ index, moveChip, ...props }) => {
//   const ref = React.useRef(null);
//   const [, drop] = useDrop({
//     accept: DragTypes.CHIP,
//     hover(item, monitor) {
//       if (!ref.current) {
//         return;
//       }
//       const dragIndex = item.index;
//       const hoverIndex = index;
//       if (dragIndex === hoverIndex) {
//         return;
//       }
//       const hoverBoundingRect = ref.current?.getBoundingClientRect();
//       const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
//       const clientOffset = monitor.getClientOffset();
//       const hoverClientY = clientOffset.y - hoverBoundingRect.top;
//       if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
//         return;
//       }
//       if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
//         return;
//       }
//       moveChip(dragIndex, hoverIndex);
//       item.index = hoverIndex;
//     },
//   });
//   const [{ isDragging }, drag] = useDrag({
//     type: DragTypes.CHIP,
//     item: () => {
//       return { index };
//     },
//     collect: (monitor) => ({
//       isDragging: monitor.isDragging(),
//     }),
//   });
//   const opacity = isDragging ? 0.5 : 1;
//   drag(drop(ref));
//   return (
//     <div ref={ref} style={{ opacity ,width:'90%'}}>
//       <Chip {...props}  />
//     </div>
//   );
// };

// const CombinedChipInput = ({ onChipChange, placeholder, titlePlaceholder, descriptionPlaceholder, question, values, required, minRows }) => {
//   const [titleValue, setTitleValue] = useState('');
//   const [descriptionValue, setDescriptionValue] = useState('');
//   const [chips, setChips] = useState(values || []);

//   const handleAddChip = () => {
//     if (titleValue.trim() !== '' && descriptionValue.trim() !== '') {
//       const combinedChip = {
//         title: titleValue.trim(),
//         description: descriptionValue.trim()
//       };
//       setChips([...chips, combinedChip]);
//       setTitleValue('');
//       setDescriptionValue('');
//       if (onChipChange) {
//         onChipChange([...chips, combinedChip]);
//       }
//     }
//   };

//   const handleChipDelete = (index) => {
//     const newChips = [...chips];
//     newChips.splice(index, 1);
//     setChips(newChips);
//     if (onChipChange) {
//       onChipChange(newChips);
//     }
//   };

//   const moveChip = (dragIndex, hoverIndex) => {
//     const draggedChip = chips[dragIndex];
//     const newChips = [...chips];
//     newChips.splice(dragIndex, 1);
//     newChips.splice(hoverIndex, 0, draggedChip);
//     setChips(newChips);
//     if (onChipChange) {
//       onChipChange(newChips);
//     }
//   };

//   useEffect(() => {
//     setChips(values || []); // Update chips when values prop changes
//   }, [values]);

//   return (
//     <DndProvider backend={HTML5Backend} >
//       <div>
//         <div style={{ margin: '5px', color: '#131F32', fontSize: '14px', fontWeight: '600', lineHeight: '24px',width:'200px' }}>
//           {question} {required && <span style={{ color: 'red' }}>*</span>}
//         </div>
//         <div style={{display:'flex',flexDirection:'column'}}>
//           {chips.map((chip, index) => (
//           <div style={{display:'flex',flexDirection:'row'}}>
//             <DragIndicatorIcon sx={{marginTop:'9px',color:'#808080'}}/>
//             <DraggableChip
//               key={index}
//               index={index}
//               moveChip={moveChip}
            
//               label={`${chip.title}: ${chip.description}`}
//               onDelete={() => handleChipDelete(index)}
//               variant="outlined"
//               style={{ marginRight: '8px', marginBottom: '8px', marginTop:'5px', cursor: 'pointer' }}
//             />
//             </div>  
//           ))}
//         </div>
//         <TextField
//           value={titleValue}
//           onChange={(e) => setTitleValue(e.target.value)}
//           size='small'
//           placeholder={titlePlaceholder || "Title"}
//           fullWidth
//           variant="outlined"
//           sx={{
//             width: '100%',
//             marginBottom:'10px',
//             marginTop: '5px',
//             '& label.Mui-focused': {
//               color: '#333',
//             },
//             '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
//               borderColor: '#808080',
//             },
//             borderRadius: '20px',
//           }}
//         />
//         <TextField
//           value={descriptionValue}
//           onChange={(e) => setDescriptionValue(e.target.value)}
//           size='small'
//           placeholder={descriptionPlaceholder || "Description"}
//           fullWidth
//           variant="outlined"
//           sx={{
//             width: '100%',
//             marginBottom:'10px',
//             marginTop: '5px',
//             '& label.Mui-focused': {
//               color: '#333',
//             },
//             '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
//               borderColor: '#808080',
//             },
//             borderRadius: '20px',
//           }}
//         />
//         <Button onClick={handleAddChip} variant="standard" sx={{color:'#131c32',justifyContent:'center',alignItems:'center',textAlign:'center'}}>Add a new Section</Button>
//       </div>
//     </DndProvider>
//   );
// };

// export default CombinedChipInput;
import React, { useEffect, useState } from 'react';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
const DragTypes = {
  CHIP: 'chip',
};

const DraggableChip = ({ index, moveChip, ...props }) => {
  const ref = React.useRef(null);
  const [, drop] = useDrop({
    accept: DragTypes.CHIP,
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      if (dragIndex === hoverIndex) {
        return;
      }
      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      moveChip(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
  });
  const [{ isDragging }, drag] = useDrag({
    type: DragTypes.CHIP,
    item: () => {
      return { index };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  const opacity = isDragging ? 0.5 : 1;
  drag(drop(ref));
  return (
    <div ref={ref} style={{ opacity ,width:'90%'}}>
      <Chip  {...props}  />
    </div>
  );
};

const CombinedChipInput = ({ onChipChange, placeholder, titlePlaceholder, descriptionPlaceholder, question, values, required, minRows }) => {
  const [titleValue, setTitleValue] = useState('');
  const [descriptionValue, setDescriptionValue] = useState('');
  const [chips, setChips] = useState(values || []);

  const handleAddChip = () => {
    if (titleValue.trim() !== '' && descriptionValue.trim() !== '') {
      const combinedChip = {
        title: titleValue.trim(),
        description: descriptionValue.trim()
      };
      setChips([...chips, combinedChip]);
      setTitleValue('');
      setDescriptionValue('');
      if (onChipChange) {
        onChipChange([...chips, combinedChip]);
      }
    }
  };

  const handleChipDelete = (index) => {
    const newChips = [...chips];
    newChips.splice(index, 1);
    setChips(newChips);
    if (onChipChange) {
      onChipChange(newChips);
    }
  };

  const moveChip = (dragIndex, hoverIndex) => {
    const draggedChip = chips[dragIndex];
    const newChips = [...chips];
    newChips.splice(dragIndex, 1);
    newChips.splice(hoverIndex, 0, draggedChip);
    setChips(newChips);
    if (onChipChange) {
      onChipChange(newChips);
    }
  };

  const handleChipClick = (index) => {
    setTitleValue(chips[index].title);
    setDescriptionValue(chips[index].description);
  };

  useEffect(() => {
    setChips(values || []); // Update chips when values prop changes
  }, [values]);

  return (
    <DndProvider backend={HTML5Backend} >
      <div>
        <div style={{ margin: '5px', color: '#131F32', fontSize: '14px', fontWeight: '600', lineHeight: '24px',width:'100%' }}>
          {question} {required && <span style={{ color: 'red' }}>*</span>}
        </div>
        <div style={{display:'flex',flexDirection:'column'}}>
          {chips.map((chip, index) => (
          <div style={{display:'flex',flexDirection:'row'}}>
            <DragIndicatorIcon sx={{marginTop:'9px',color:'#808080'}}/>
            <DraggableChip
              key={index}
              index={index}
              moveChip={moveChip}
            
              onClick={() => handleChipClick(index)}
              label={`${chip.title}: ${chip.description}`}
              onDelete={() => handleChipDelete(index)}
              variant="outlined"
              style={{ marginRight: '8px', marginBottom: '8px', marginTop:'5px', cursor: 'pointer' }}
            />
            </div>  
          ))}
        </div>
        <TextField
          value={titleValue}
          onChange={(e) => setTitleValue(e.target.value)}
          size='small'
          placeholder={titlePlaceholder || "Title"}
          fullWidth
      
          variant="outlined"
          sx={{
            width: '100%',
            marginBottom:'10px',
            marginTop: '5px',
            '& label.Mui-focused': {
              color: '#333',
            },
            '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#808080',
            },
            borderRadius: '20px',
          }}
        />
        <TextField
          value={descriptionValue}
          onChange={(e) => setDescriptionValue(e.target.value)}
          size='small'
          placeholder={descriptionPlaceholder || "Description"}
          fullWidth
          minRows={3}
          multiline
          variant="outlined"
          sx={{
            width: '100%',
            marginBottom:'10px',
            marginTop: '5px',
            '& label.Mui-focused': {
              color: '#333',
            },
            '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#808080',
            },
            borderRadius: '20px',
          }}
        />
        <div
                    style={{
                      fontSize: '16px',
                      color: '#159DFF',
                      cursor: 'pointer',
                    }}
                    onClick={handleAddChip}
                  >Add Section</div>
      </div>
    </DndProvider>
  );
};

export default CombinedChipInput;
